<template>
	<section class="text-info mt-5">
		<h1>{{randomMessages.title}}</h1>
		<h4>
			{{ randomMessages.message }}
			<router-link to="/">{{ randomMessages.linkText}}</router-link>.
		</h4>
	</section>
</template>

<script>
export default {
	data() {
		return {
			errorMessages : [
				{
					title: 'Doh! Looks like an Error...',
					message: "was it you? was it us? was it the flashy shortstop who is all talk? let's try that again..",
					linkText: 'home'
				},
				{
					title: 'Thats strike three..',
					message: "that one hurt, you'll be thinking about that for awhile. go have some seeds and find a cozy spot in the ",
					linkText: 'dugout'
				},
				{
					title: 'Just a little outside...',
					message: "seems like our control is a little off... we will be in the",
					linkText: 'bullpen'
				}
			]
		}
	},
	computed: {
		randomMessages() {
			const random = this.errorMessages[Math.floor(Math.random() * this.errorMessages.length)]
			return random
		}
	}
}
</script>